<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { onMount } from "svelte";


    export let start_date, end_date;

    onMount(() => {
        daterange_picker(start_date,end_date);
    });

    function daterange_picker(start, end) {
        moment.locale("de");
        var start = start;
        var end = end;

        function cb(selectedStartDate, selectedEndDate) {
            window.jQuery('#kai-datepicker span')
                .html(
                    selectedStartDate.format("DD.MM.YY") +
                        " - " +
                        selectedEndDate.format("DD.MM.YY"),
                );
            // Update the global selected_daterange variable
                start_date = new Date(selectedStartDate)
                end_date = new Date(selectedEndDate)
        }

        // Initialize the date range picker with options
        window.jQuery('#kai-datepicker').daterangepicker(
            {
                startDate: start,
                endDate: end,
                showDropdowns: true,
                timePicker: true,
                timePicker24Hour: true,
                linkedCalendars: false,
                minDate: "01.01.2000",
                maxDate: "31.12.2035",
                ranges: {
                    Heute: [moment().startOf("day"), moment()],
                    Gestern: [
                        moment().subtract(1, "days").startOf("day"),
                        moment().subtract(1, "days").endOf("day"),
                    ],
                    "Letzte 7 Tage": [moment().subtract(6, "days"), moment()],
                    "Letzte 30 Tage": [moment().subtract(29, "days"), moment()],
                    "Dieser Monat": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                    ],
                    "Letzter Monat": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "month").endOf("month"),
                    ],
                },
                locale: {
                    separator: " - ",
                    applyLabel: "Übernehmen",
                    cancelLabel: "Abbrechen",
                    fromLabel: "Von",
                    toLabel: "Bis",
                    customRangeLabel: "Auswahl",
                    weekLabel: "W",
                    daysOfWeek: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                    monthNames: [
                        "Januar",
                        "Februar",
                        "März",
                        "April",
                        "Mai",
                        "Juni",
                        "Juli",
                        "August",
                        "September",
                        "Oktober",
                        "November",
                        "Dezember",
                    ],
                    firstDay: 1,
                },
                alwaysShowCalendars: true,
                drops: "down",
                opens: "right", // Set the dropdown to open on the right side
                autoUpdateInput: false, // Prevent automatic input update
            },
            cb,
        );

        cb(start, end);
    }

</script>

<div
    class="dropdown btn-distance"
    id="daterange_select"
>
        <div id="kai-datepicker" class="kai-datepicker btn btn-primary dropdown-toggle">
            <i class="fa fa-calendar"></i>&nbsp;&nbsp;<span class="date-picker-date"></span>&nbsp;
        </div>
</div>
